module.exports = __webpack_public_path__ + "img/ezCrs-ngang.0c5da092.png";